import React, { useEffect, useMemo, useState } from "react"
import { Box, Button, Chip, Divider, Stack, Typography, } from "@mui/material";
import { useNavigate, useLocation } from 'react-router-dom';
import ItemResolver from "../items/ItemResolver.js";
import { getNumericTimer } from "../sports/genericUtils.js";
import CustomDivider from "../dsasComponents/CustomDivider.js";

const ActuView = ({ actu, loadMore  }) => {

    const defaultVisible = 10

    const [pinItems, setPinItems] = useState([])

    const [items, setItems] = useState([])
    const [visibleItems, setVisibleItems] = useState(defaultVisible);

    const location = useLocation(); // Utilisation de useLocation pour récupérer l'URL
    const queryParams = new URLSearchParams(location.search); // Récupérer les query params
    const tagsFromUrl = queryParams.get('tags') ? queryParams.get('tags').split(',') : []; // Obtenir les tags de l'URL (si présents)

    //advanced options & button custom
    const redirectUrlFromUrl = queryParams.get('redirect-url');
    const displayTextFromUrl = queryParams.get('display-text');
    const buttonPositionFromUrl = queryParams.get('button-position') || 'top';

    useEffect(() => {

        // Le but ici est de trier les items
        let buildQuestionBoxes = actu.questionBoxes ? actu.questionBoxes.map(i => ({...i, type : 'questionBox'})) : []
        let buildMedias = actu.quizzs ? actu.quizzs.map(i => ({...i, type : 'quizz'})) : []
        let buildSurveys = actu.surveys ? actu.surveys.map(i => ({...i, type : 'survey'})) : []
        let buildNotations = actu.notations ? actu.notations.map(i => ({...i, type : 'notation'})) : []
        let buildArticles = actu.articles ? actu.articles.map(i => ({...i, type : 'article'})) : []


         const sortThings = (a, b) => new Date(b.displayDate || b.creation) - new Date(a.displayDate || a.creation);

            // const sortThings = (a, b) => {
                
            //     let bDate = b.displayDate ? new Date(b.displayDate) : new Date(b.creation)
            //     let aDate = a.displayDate ? new Date(a.displayDate) : new Date(a.creation)
    
            //     if(bDate < aDate)
            //         return -1
            //     if(aDate > bDate)
            //         return 1
            //     return 0; // Ajouté pour éviter des erreurs de tri
            // }

            // Filtrer les items par tags présents dans l'URL
            const filterByTags = (items) => {
                if (tagsFromUrl.length === 0) return items; // Si aucun tag, on ne filtre pas
                return items.filter(item => item.tags && item.tags.some(tag => tagsFromUrl.includes(tag)));
            };

            // Filtrage et tri des éléments
            const filteredQuestionBoxes = filterByTags(buildQuestionBoxes);
            const filteredMedias = filterByTags(buildMedias);
            const filteredSurveys = filterByTags(buildSurveys);
            const filteredNotations = filterByTags(buildNotations);
            const filteredArticles = filterByTags(buildArticles);

            setPinItems(
                filteredMedias.filter(g => g.isPin)
                    .concat(filteredQuestionBoxes.filter(g => g.isPin))
                    .concat(filteredSurveys.filter(g => g.isPin))
                    .concat(filteredNotations.filter(g => g.isPin))
                    .concat(filteredArticles.filter(g => g.isPin))
                    .sort(sortThings)
            );
    
            setItems(
                filteredMedias.filter(g => !g.isPin)
                    .concat(filteredQuestionBoxes.filter(g => !g.isPin))
                    .concat(filteredSurveys.filter(g => !g.isPin))
                    .concat(filteredNotations.filter(g => !g.isPin))
                    .concat(filteredArticles.filter(g => !g.isPin))
                    .sort(sortThings)
            );
    }, [actu])

    const handleShowMore = async () => {

        if (!actu || !actu.hasMore) {
            console.warn("handleShowMore appelé alors que actu.hasMore est false ou undefined");
            return;
        }

        if(actu.hasMore)
            await loadMore()

        const newVisibleItems = visibleItems + defaultVisible;
        setVisibleItems(newVisibleItems);
    };

    const disabledShowMore = useMemo(() => {
        return visibleItems >= items.length
        && !actu.hasMore
    }, [actu.hasMore, visibleItems, items])



    return (
        <Box>

                    <Box sx={{ display : 'flex', justifyContent : 'flex-start', alignItems : 'flex-start', ml : '1.2em', mb : '1em'}}>
                        <Box sx={{
                                float : 'left',
                                color : 'white',
                                width : 'fit-content',
                                padding : "3px 9px 3px 7px",
                                display : 'flex',
                                background: '#CB1F1F 0% 0% no-repeat padding-box',
                                borderRadius: '20px',
                                mt : 1}}>
                                    <Typography sx={{fontSize : '0.7em', whiteSpace : 'nowrap'}}>&bull; DIRECT</Typography>

                        </Box>
                        <Typography 
                            gutterBottom  
                            component="div" 
                            variant="h1"
                            sx={{mt : ".3em", 
                            mb : '.3em', 
                            ml : ".4em", 
                            textTransform : 'none',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            }}>
                                {actu.name}
                        </Typography>                
                    </Box>

                {/*
                    Presentation des tags
                */}
                <TagsDisplay actu={actu} /> {/* Composant d'affichage des tags */}

                {/* Bouton custom issu de l'URL, si présent et positionné en haut */}
                    {redirectUrlFromUrl && displayTextFromUrl && buttonPositionFromUrl === 'top' && (
                    <CustomRedirectButton
                        redirectUrl={redirectUrlFromUrl}
                        displayText={displayTextFromUrl}
                    />
                    )}
                    

                
                {pinItems.length>0 && <Stack spacing={0}>
                    {pinItems.map((t, idx) =>
                        <React.Fragment key={t._id}>
                            <ItemResolver item={t} match={actu} />
                        </React.Fragment>
                    )}
                    <CustomDivider/>
                </Stack>}
                <Stack spacing={0}>
                {items.slice(0, visibleItems).map((t, idx) => 
                    <React.Fragment key={t._id}>
                        <ItemResolver item={t} match={actu} />
                        <CustomDivider disabled={idx===items.slice(0, visibleItems).length - 1 ? true : false}/>
                    </React.Fragment>
                )}
                </Stack>
                {!disabledShowMore ? (
                    <BottomButton label="Voir plus" onClick={handleShowMore}/>
                ) : (
                    <BottomButton label="Début du direct"/>
                    
                )}
                {/* Bouton custom en bas de page, si demandé */}
                {redirectUrlFromUrl && displayTextFromUrl && buttonPositionFromUrl === 'bottom' && (
                <CustomRedirectButton
                    redirectUrl={redirectUrlFromUrl}
                    displayText={displayTextFromUrl}
                />
                )}
        </Box>
        )

}

const BottomButton = ({label, onClick}) => {

    const disabled = onClick === undefined

    return (
    <Box sx={{position : 'relative', width : '100%', pb : '1em', mt : 5}}>
        <div style={{position : 'absolute', bottom : '10px', width : '100%'}}>
            <CustomDivider/>
        </div>
        
        <Button sx={{
            position : 'absolute', 
            bottom : 0, 
            left : '50%',
            transform : 'translateX(-50%)',
            width : 'fit-content', 
            backgroundColor : disabled ? "rgba(200,200,200,1) !important" : "rgba(0,0,0,1) !important", 
            color : disabled ? 'rgb(50,50,50) !important' : 'white !important', 
            boxShadow : 'none',
            borderRadius : '20px',
            cursor: disabled ? 'not-allowed' : 'pointer',
        }} 
            
            onClick={onClick ? onClick : () => {}} 
            disabled={disabled}
            variant="contained">
            {label}
        </Button>
    </Box>
    
    )
}

const CustomRedirectButton = ({ redirectUrl, displayText }) => {
  if (!redirectUrl) return null;

  let finalUrl = redirectUrl.trim();

  // Si l'URL ne commence pas par http:// ou https://, on ajoute https://
  if (!/^https?:\/\//i.test(finalUrl)) {
    finalUrl = 'https://' + finalUrl;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
      <Button
        variant="contained"
        onClick={() => window.open(finalUrl, '_blank', 'noopener,noreferrer')}
        sx={{
          borderRadius: '20px',
          textTransform: 'none',
          px: 3,
          py: 0.8,
          fontWeight: 300,
        }}
      >
        {displayText}
      </Button>
    </Box>
  );
};

const TagsDisplay = ({ actu }) => {


    const navigate = useNavigate();
    const location = useLocation();
  
    // Fonction pour mettre à jour les tags dans l'URL
    const handleTagClick = (tagId) => {
      const searchParams = new URLSearchParams(location.search);
      const currentTags = searchParams.get('tags') ? searchParams.get('tags').split(',') : [];
  
      // Si le tag est déjà présent, on le retire, sinon on l'ajoute
      if (currentTags.includes(tagId)) {
        const updatedTags = currentTags.filter((t) => t !== tagId);
        updatedTags.length > 0 ? searchParams.set('tags', updatedTags.join(',')) : searchParams.delete('tags');
      } else {
        currentTags.push(tagId);
        searchParams.set('tags', currentTags.join(','));
      }
  
      // Mettre à jour l'URL
      navigate({
        pathname: location.pathname,
        search: searchParams.toString(),
      });
  
      // Forcer le rechargement de la page
      window.location.reload(); // Recharge la page après la mise à jour de l'URL
    };

    // Récupérer les tags actuels de l'URL
    const selectedTags = new URLSearchParams(location.search).get('tags')?.split(',') || [];

    // Récupérer les tags des médias (quizzs, surveys, notations, articles)
    const mediaTags = [
        ...(actu.quizzs ? actu.quizzs.flatMap((q) => q.tags || []) : []),
        ...(actu.surveys ? actu.surveys.flatMap((s) => s.tags || []) : []),
        ...(actu.notations ? actu.notations.flatMap((n) => n.tags || []) : []),
        ...(actu.articles ? actu.articles.flatMap((a) => a.tags || []) : []),
    ];

    // Concaténer les tags de actu.usedTags et les tags des médias, puis retirer les doublons
    const allUsedTags = useMemo(() => {
        const usedTags = [...new Set([...actu.usedTags, ...mediaTags.map(tag => tag.toString())])];

        return usedTags.filter(t => actu.tags.find((tag) => tag._id === t))
    }, [actu])

    useEffect(() => {

        const searchParams = new URLSearchParams(location.search);
        const currentTags = searchParams.get('tags') ? searchParams.get('tags').split(',') : [];

        // Filtrer les tags qui ne sont plus disponibles dans allUsedTags
        const validTags = currentTags.filter(tag => allUsedTags.includes(tag));

        // Si certains tags sont invalides, on met à jour l'URL
        if (validTags.length !== currentTags.length) {
            if (validTags.length > 0) {
                searchParams.set('tags', validTags.join(','));
            } else {
                searchParams.delete('tags');
            }

            // Mettre à jour l'URL sans forcer un rechargement de la page
            navigate({
                pathname: location.pathname,
                search: searchParams.toString(),
            });

            // Forcer le rechargement de la page
            window.location.reload(); // Recharge la page après la mise à jour de l'URL
        }


    }, [allUsedTags, location.search, navigate]);
  
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
          {allUsedTags.map((usedTagId) => {
            const tag = actu.tags.find((tag) => tag._id === usedTagId);
            const isSelected = tag && selectedTags.includes(tag._id); // Vérifier si le tag est dans l'URL
            return tag ? (
              <Chip 
                key={tag._id} 
                label={tag.name} 
                onClick={() => handleTagClick(tag._id)} // Rendre le Chip cliquable
                sx={{
                  backgroundColor: isSelected ? '#3f51b5' : '#f1f1f1', // Couleur plus visible si sélectionné
                  color: isSelected ? '#fff' : '#333', // Texte en blanc si sélectionné
                  borderRadius: '16px',
                  cursor: 'pointer', // Changer le curseur pour indiquer que c'est cliquable
                  '&:hover': {
                    backgroundColor: isSelected ? '#303f9f' : '#e0e0e0', // Effet au hover (change légerement)
                  },
                }} 
              />
            ) : null;
          })}
        </Box>
    );
  };

export default ActuView